import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const EmployerInformation = ({
  refEmployerHuman,
  refEmployerDomicileHuman,
  refActivityBeingCarriedOutHuman,
  refWorkActivityHuman,
  refactivitySeniority,
}) => {
  const data = useLocation();

  const [employerInformation, setEmployerInformation] = useState({
    employer: data.state.data.EmployerInformation.employer || "",
    employerDomicile:
      data.state.data.EmployerInformation.employerDomicile || "",
    ActivityBeingCarriedOut:
      data.state.data.EmployerInformation.ActivityBeingCarriedOut || "",
    workActivity: data.state.data.EmployerInformation.WorkActivity || "",
    activitySeniority:
      data.state.data.EmployerInformation.activitySeniority || "",
  });

  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate">Informacion Empleador</p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Empleador:</label>
          <input
            ref={refEmployerHuman}
            className="inputupdate"
            type="text"
            defaultValue={employerInformation.employer}
            onChange={(e) =>
              setEmployerInformation({
                ...employerInformation,
                employer: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Domicilio empleador:
          </label>
          <input
            ref={refEmployerDomicileHuman}
            className="inputupdate"
            type="text"
            defaultValue={employerInformation.employerDomicile}
            onChange={(e) =>
              setEmployerInformation({
                ...employerInformation,
                employerDomicile: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Actividad laboral:
          </label>
          <input
            ref={refWorkActivityHuman}
            className="inputupdate"
            type="text"
            defaultValue={employerInformation.workActivity}
            onChange={(e) =>
              setEmployerInformation({
                ...employerInformation,
                workActivity: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Antiguedad en la actividad:
          </label>
          <input
            ref={refactivitySeniority}
            className="inputupdate"
            type="number"
            defaultValue={employerInformation.activitySeniority}
            onChange={(e) =>
              setEmployerInformation({
                ...employerInformation,
                activitySeniority: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Actividad que desarrolla:
          </label>
          <textarea
            ref={refActivityBeingCarriedOutHuman}
            className="inputupdate"
            type="text"
            defaultValue={employerInformation.ActivityBeingCarriedOut}
            onChange={(e) =>
              setEmployerInformation({
                ...employerInformation,
                ActivityBeingCarriedOut: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default EmployerInformation;
